if (document.querySelector('.splide_grid')) {
  document.querySelectorAll('.splide_grid').forEach(function (grid) {
    const customPagination = grid.querySelector('.custom_pagination');

    if (grid.classList.contains('blog-grid')) {
      console.log('blog grid');
      var splide = new Splide(grid, {
        perPage: 3,
        gap: '40px',
        arrows: false,
        pagination: true,
        speed: 600,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          600: {
            perPage: 1,
          },
        },
      });
    } else {
      var splide = new Splide(grid, {
        perPage: 4,
        gap: '8px',
        arrows: false,
        pagination: true,
        speed: 600,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          600: {
            perPage: 1,
          },
        },
      });
    }

    splide.on('mounted move', () => {
      customPagination.innerHTML = '';
      const totalPages = splide.Components.Controller.getEnd() + 1;

      if (totalPages == 1) {
        grid.querySelector('.pagination_controls').classList.add('hidden');
      }

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.classList.add('splide__pagination__page');
        if (i === splide.index) {
          dot.classList.add('is-active');
        }
        dot.addEventListener('click', () => {
          splide.go(i);
        });
        customPagination.appendChild(dot);
      }

      const progressBarFill = grid.querySelector('.progress_bar_fill');
      const progress = (splide.index / splide.Components.Controller.getEnd()) * 100;
      progressBarFill.style.width = progress + '%';
    });

    splide.mount();

    const prevButton = grid.querySelector('.prev_button');
    const nextButton = grid.querySelector('.next_button');

    if (prevButton) {
      prevButton.addEventListener('click', () => splide.go('-1'));
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => splide.go('+1'));
    }
  });
}

if (document.querySelector('#partner-logos')) {
  let splide = new Splide('#partner-logos', {
    type: 'loop',
    drag: 'free',
    // focus: 'center',
    pagination: false,
    arrows: false,
    gap: '60px',
    autoWidth: true,
    autoScroll: {
      speed: 0.6,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);
}

if (document.querySelector('#scrolling-banner')) {
  let splide = new Splide('#scrolling-banner', {
    type: 'loop',
    drag: 'free',
    pagination: false,
    arrows: false,
    gap: '20px',
    focus: 'center',
    autoWidth: true,
    autoScroll: {
      speed: 0.8,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);
}

if (document.querySelector('#also-like-collections-splider')) {
  let splide = new Splide('#also-like-collections-splider', {
    pagination: false,
    arrows: false,
    gap: '32px',
    // autoWidth: true,
    trimSpace: false,
  });

  let leftButton = document.getElementById('also-like-left-arrow');
  let rightButton = document.getElementById('also-like-right-arrow');

  splide.on('mounted move', function () {
    if (splide.index === 0) {
      leftButton.classList.add('disabled');
    } else {
      leftButton.classList.remove('disabled');
    }

    if (splide.index === splide.Components.Controller.getEnd()) {
      rightButton.classList.add('disabled');
      document.querySelector('.blurred_overlay').classList.add('hidden');
    } else {
      rightButton.classList.remove('disabled');
      document.querySelector('.blurred_overlay').classList.remove('hidden');
    }
  });

  leftButton.addEventListener('click', function () {
    splide.go('-1');
  });

  rightButton.addEventListener('click', function () {
    splide.go('+1');
  });

  splide.mount();
}

function initProductMediaGalleries(root) {
  root.querySelectorAll('.main_product_image.splide').forEach((galleryEl) => {
    if (galleryEl.dataset.splideInitialized) return;
    galleryEl.dataset.splideInitialized = 'true';

    let splide = new Splide(galleryEl, {
      type: 'loop',
      perPage: 1,
      pagination: false,
      arrows: false,
      gap: '0px',
      width: '100%',
    });

    splide.mount();

    const galleryRoot = galleryEl.closest('media-gallery') || root;
    const thumbnails = galleryRoot.querySelectorAll('.left .product__media-item');
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = parseInt(thumbnail.getAttribute('thumbnail-index'));
        splide.go(index);
      });
    });

    splide.on('move', () => {
      const currentIndex = splide.index;
      thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove('active');
        const thumbIndex = parseInt(thumbnail.getAttribute('thumbnail-index'));
        if (thumbIndex === currentIndex) {
          thumbnail.classList.add('active');
        }
      });
    });
  });
}

function openProductMediaLightbox(item) {
  const media = item.querySelector('img, video, iframe');
  if (!media) return;

  const lightbox = document.createElement('div');
  lightbox.className = 'media-lightbox';
  lightbox.style.cssText =
    'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.9); z-index: 9999; display: flex; align-items: center; justify-content: center;';

  const mediaClone = media.cloneNode(true);
  mediaClone.style.cssText = 'max-width: 90%; max-height: 90vh; object-fit: contain;';

  if (mediaClone.tagName === 'VIDEO') {
    mediaClone.muted = false;
    mediaClone.removeAttribute('muted');
    mediaClone.setAttribute('controls', 'true');
    mediaClone.play();
  }

  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '&times;';
  closeBtn.style.cssText =
    'position: absolute; top: 20px; right: 30px; color: white; font-size: 40px; background: none; border: none; cursor: pointer;';

  lightbox.appendChild(mediaClone);
  lightbox.appendChild(closeBtn);
  document.body.appendChild(lightbox);

  const closeLightbox = () => lightbox.remove();
  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
}

function initProductMediaLightbox(root) {
  root.querySelectorAll('.main_product_image .product__media-item').forEach((item) => {
    if (item.dataset.lightboxBound) return;
    item.dataset.lightboxBound = 'true';
    item.style.cursor = 'pointer';
    item.addEventListener('click', (e) => {
      e.preventDefault();
      openProductMediaLightbox(item);
    });
  });

  // Lets the "Play video" button next to the Description tab jump straight
  // to the product video without the shopper having to find it in the gallery.
  root.querySelectorAll('[data-play-product-video]').forEach((button) => {
    if (button.dataset.lightboxBound) return;
    button.dataset.lightboxBound = 'true';
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const productRoot = button.closest('product-info') || root;
      const gallery = productRoot.querySelector('.main_product_image');
      if (!gallery) return;

      const videoItem = Array.from(gallery.querySelectorAll('.product__media-item')).find((item) =>
        item.querySelector('video, iframe'),
      );
      if (videoItem) openProductMediaLightbox(videoItem);
    });
  });
}

function initProductMedia(root = document) {
  initProductMediaGalleries(root);
  initProductMediaLightbox(root);
}

window.initProductMedia = initProductMedia;
initProductMedia();

if (document.querySelector('#home-hero-mob')) {
  let splide = new Splide('#home-hero-mob', {
    type: 'loop',
    perPage: 1,
    pagination: true,
    arrows: false,
    gap: '0px',
    width: '100%',
  });

  splide.mount();
}
